const testimonials = [
  {
    name: "Rachel M.",
    location: "Valdosta, GA",
    rating: 5,
    text: "I had a spring break cruise leaving from Jacksonville in 5 days and my passport expired last month. Fast Passport Center got my renewal done in 4 days. I shipped from the UPS Store on Norman Drive and everything was seamless. Saved my family's vacation!",
    service: "Passport Renewal",
  },
  {
    name: "James T.",
    location: "Hahira, GA",
    rating: 5,
    text: "My daughter needed a passport for a study abroad program at Valdosta State. We had no idea about the two-parent consent rule. Fast Passport Center sent us a step-by-step checklist, told us exactly which forms to bring to the Valdosta post office, and got it processed in 7 days. Incredible service.",
    service: "Child Passport",
  },
  {
    name: "Patricia L.",
    location: "Thomasville, GA",
    rating: 5,
    text: "Business trip to Toronto in 10 days and I lost my passport somewhere between here and Albany. Called Fast Passport Center on a Monday, had my replacement by Thursday evening. They even walked me through the DS-64 form over the phone. Professional and fast.",
    service: "Lost Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function ValdostaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Valdosta &amp; South Georgia Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Valdosta, Hahira, Thomasville, and south Georgia who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}